import styles from './Footer.module.css';

const Footer = () => {
  return <footer className={styles.footer}>Footer</footer>;
};

export default Footer;
